import { AssetTypesLocalized, FieldType, FilterFormDataModel, PROMPTS, WidthClass } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { BuyoutRights, LicenseRegion } from '@thehubz/shared/model';
import { creatorDepartmentObj } from '../../components/asset-upload/stepper-config/asset-settings-stepper.constants';
import { Channel, Subject } from './vorwerk-metadata-config';

export const Product = [
  { _id: 'test', name: 'Test' },
  { _id: 'test2', name: 'Test1' },
];

export const Domain = [
  { _id: 'public', name: 'Public' },
  { _id: 'own_subsidiary', name: 'Own subsidiary' },
  { _id: 'distributors', name: 'Distributors' },
];

export const vorwerkFilterFormData: FilterFormDataModel = {
  title: 'Asset',
  description: '',
  customClient: CustomClients.Vorwerk,
  formFields: [
    {
      formTypeId: '1',
      formFieldName: 'assetType',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Asset type`,
      placeholder: $localize`:placeholder:-- All types --`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      subProjectFlag: false,
      disable: false,
      multiple: true,
      visible: true,
      options: AssetTypesLocalized,
    },
    {
      formTypeId: '2',
      formFieldName: 'channel',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Channel`,
      placeholder: $localize`:placeholder:-- All channel --`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      disable: false,
      formGroup: true,
      multiple: true,
      visible: true,
      options: Channel,
    },
    {
      formTypeId: '3',
      formFieldName: 'subject',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Subject`,
      placeholder: $localize`:placeholder:-- All subjects --`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      subProjectFlag: false,
      disable: false,
      visible: true,
      multiple: true,
      options: Subject,
    },
    {
      formTypeId: '4',
      formFieldName: 'status',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Status`,
      placeholder: $localize`:placeholder:-- All Status --`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      subProjectFlag: false,
      disable: false,
      visible: true,
      multiple: true,
      options: [],
    },
    {
      formTypeId: '5',
      formFieldName: 'publishedDate-label',
      fieldLabel: $localize`Published Date`,
      fieldType: FieldType.Label,
      placeholder: '',
      visible: false,
      widthClass: WidthClass.WFull,
    },
    {
      formTypeId: '6',
      formFieldName: 'publishedDate_from',
      fieldType: FieldType.Date,
      fieldLabel: $localize`From`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: false,
    },
    {
      formTypeId: '7',
      formFieldName: 'publishedDate_until',
      fieldType: FieldType.Date,
      fieldLabel: $localize`Until`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: false,
    },
    {
      formTypeId: '8',
      formFieldName: 'agency',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Domain`,
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      subProjectFlag: false,
      disable: false,
      functionCall: true,
      formGroup: true,
      visible: true,
      options: [],
    },
    {
      formTypeId: '9',
      formFieldName: 'client',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Location`,
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      subProjectFlag: false,
      disable: false,
      functionCall: true,
      formGroup: true,
      visible: true,
      options: [],
    },
    {
      formTypeId: '10',
      formFieldName: 'brand',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Brand`,
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      disable: false,
      formGroup: true,
      visible: true,
      options: [],
    },
    {
      formTypeId: '11',
      formFieldName: 'category',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Category`,
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      disable: false,
      formGroup: true,
      visible: false,
      options: [],
    },
    {
      formTypeId: '12',
      formFieldName: 'product',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Product`,
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      disable: false,
      formGroup: true,
      visible: false,
      options: [],
    },
    {
      formTypeId: '13',
      formFieldName: 'subcategory',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Sub-category`,
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      disable: false,
      formGroup: true,
      visible: false,
      options: [],
    },
    {
      formTypeId: '14',
      formFieldName: 'date-label',
      fieldLabel: $localize`Date created`,
      fieldType: FieldType.Label,
      placeholder: '',
      visible: true,
      widthClass: WidthClass.WFull,
    },
    {
      formTypeId: '15',
      formFieldName: 'createdDate_from',
      fieldType: FieldType.Date,
      fieldLabel: $localize`From`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: true,
    },
    {
      formTypeId: '16',
      formFieldName: 'createdDate_to',
      fieldType: FieldType.Date,
      fieldLabel: $localize`To`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: true,
    },
    {
      formTypeId: '17',
      formFieldName: 'expiry-label',
      fieldLabel: $localize`Expiry date`,
      fieldType: FieldType.Label,
      placeholder: '',
      visible: true,
      widthClass: WidthClass.WFull,
    },
    {
      formTypeId: '18',
      formFieldName: 'expiryDate_from',
      fieldType: FieldType.Date,
      fieldLabel: $localize`From`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: true,
    },
    {
      formTypeId: '19',
      formFieldName: 'expiryDate_to',
      fieldType: FieldType.Date,
      fieldLabel: $localize`To`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: true,
    },
    {
      formTypeId: '20',
      formFieldName: 'creatorDepartment',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Creator department`,
      placeholder: $localize`:placeholder:-- All Creator department --`,
      inputType: '',
      mandatory: false,
      usageRightFlag: true,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      disable: false,
      visible: true,
      multiple: true,
      options: creatorDepartmentObj(CustomClients.Vorwerk),
    },
    {
      formTypeId: '21',
      formFieldName: 'buyout',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Buyout`,
      placeholder: $localize`:placeholder:-- All buyout --`,
      inputType: '',
      mandatory: false,
      usageRightFlag: true,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      disable: false,
      visible: true,
      multiple: true,
      options: BuyoutRights,
    },
    {
      formTypeId: '22',
      formFieldName: 'licenseRegion',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`License region`,
      placeholder: $localize`:placeholder:-- All License region --`,
      inputType: '',
      mandatory: false,
      usageRightFlag: true,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      disable: false,
      visible: true,
      multiple: true,
      options: LicenseRegion,
    },
    {
      formTypeId: '23',
      formFieldName: 'relationType',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Relation type`,
      placeholder: $localize`:placeholder:-- All Relation type --`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      disable: false,
      visible: true,
      multiple: true,
      options: [],
    },
    {
      formTypeId: '24',
      formFieldName: 'plannedForDeletion',
      fieldType: FieldType.Checkbox,
      fieldLabel: 'Planned for deletion',
      placeholder: '',
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      disable: false,
      visible: true,
      value: false,
    },
    {
      formTypeId: '25',
      formFieldName: 'plannedForDeletion-label',
      fieldLabel: $localize`Planned for deletion`,
      fieldType: FieldType.Label,
      placeholder: '',
      visible: false,
      widthClass: WidthClass.WFull,
    },
    {
      formTypeId: '26',
      formFieldName: 'plannedForDeletion_from',
      fieldType: FieldType.Date,
      fieldLabel: $localize`From`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: false,
    },
    {
      formTypeId: '27',
      formFieldName: 'plannedForDeletion_to',
      fieldType: FieldType.Date,
      fieldLabel: $localize`To`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: false,
    },
  ],
};
